import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AccEntrepreneurFuncData, AccVentureStatusType } from '@interfaces';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { AccCohortPageService, } from '../../../acc-cohort.page.service';
import { getSetup } from './grid/get-setup';

export interface AccEntrepreneur extends AccEntrepreneurFuncData {
	ventureName: string,
	ventureStatus: AccVentureStatusType,
	teamName: string | undefined,
	accTeamId: number,
}

@Component({
	selector: 'acc-entrepreneurs-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-entrepreneurs-view.part.html',
})
export class AccEntrepreneursViewPart {

	private readonly util = inject(UtilityService);
	private readonly dialog = inject(DialogService);
	private readonly pageService = inject(AccCohortPageService);
	private readonly areaService = inject(AcceleratorAreaService);

	public setup = getSetup(this.util, this.dialog, this.areaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public accEntrepreneurs = computed<AccEntrepreneur[]>(() => {
		const data = this.areaService.data();
		const accTeamMap = this.areaService.accTeamMap();
		if (!data) return [];

		const ventureMap = this.areaService.accVentureMap();

		return data.entrepreneurs.map(e => {
			const venture = ventureMap[e.accVentureId]!; // as we get entrepreneurs(from backend) only for existing ventures
			const accTeamId = venture.accTeamId;
			return {
				...e,
				ventureName: venture.ventureName,
				ventureStatus: venture.status,
				teamName: accTeamMap[accTeamId]?.name ?? undefined,
				accTeamId
			}
		})
	});
}